
import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 350);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Back to top"
      title="Back to top"
      tabIndex={visible ? 0 : -1}
      className={`fixed bottom-6 right-5 z-50 flex h-12 w-12 items-center justify-center rounded-full border border-[#e5c28a]/40 bg-[#30040f] text-[#e5c28a] shadow-xl shadow-black/20 transition-all duration-300 hover:-translate-y-1 hover:bg-[#4a0718] hover:shadow-2xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#e5c28a] focus-visible:ring-offset-2 focus-visible:ring-offset-white sm:bottom-8 sm:right-8 ${
        visible
          ? "translate-y-0 scale-100 opacity-100"
          : "pointer-events-none translate-y-4 scale-90 opacity-0"
      }`}
    >
      <ArrowUp size={22} strokeWidth={2.2} />
    </button>
  );
}
